module.exports = __webpack_public_path__ + "img/success-with-dg-bosspack.dc8fcdd8.svg";